import React from 'react';
import { useSlate } from 'slate-react';
import ToolbarButton from '@plone/volto-slate/editor/ui/ToolbarButton';
import icon from '@plone/volto/icons/align-center.svg';

import { isStyleActive, toggleStyle } from '../../../utils/slate';

const STYLE = 'text-center';

const AlignCenterButton = () => {
  const editor = useSlate();

  return (
    <ToolbarButton
      icon={icon}
      title="Align Center"
      active={isStyleActive(editor, STYLE)}
      onMouseDown={(e) => {
        e.preventDefault();
        toggleStyle(editor, STYLE);
      }}
    />
  );
};

export default AlignCenterButton;